import buildMeta from '@/router/utils/buildMeta'

const routes = [
  {
    name: 'match-report',
    path: '/match-report/:opportunityId',
    component: () => import('@/pages/MatchReportLegacy/MatchReportLegacy.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Match Report',
      title: 'Match Report - Jobscan',
      liveChatEnabled: true,
    }),
  },
  {
    name: 'match-report-legacy',
    path: '/match-report-legacy/:opportunityId',
    component: () => import('@/pages/MatchReportLegacy/MatchReportLegacy.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Match Report',
      title: 'Match Report - Jobscan',
      liveChatEnabled: true,
    }),
  },
  {
    name: 'match-report-sample',
    path: '/sample-report',
    component: () =>
      import('@/pages/MatchReportLegacySample/MatchReportLegacy.vue'),
    meta: buildMeta({
      authRequired: false,
      pageTitle: 'Sample Report',
      title: 'Sample Report - Jobscan',
    }),
  },
  {
    name: 'match-report-scan',
    path: '/match-report-scan',
    component: () => import('@/pages/PowerEditNew/components/Scan/Scan.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Match Report Scan',
      title: 'Match Report - Jobscan',
    }),
  },
  {
    name: 'match-report-print',
    path: '/match-report-print',
    component: () => import('@/pages/PrintableReport/PrintableReport.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Match Report Print',
      title: 'Match Report - Jobscan',
    }),
  },
]

export default routes
